import { Card } from 'antd'
import React, { FC } from 'react'
import { utils } from 'utils'
import { TCreditPaymentDetails } from '../types'

const CreditsPaymentSummary: FC<{
 data: TCreditPaymentDetails
}> = ({ data }) => {
 return (
  <div className="credit-payment-summary">
   <div className="credit-payment-item">
    <div>Plan Amount</div>
    <div>{utils.pricefy(data.sub_total)}</div>
   </div>
   <div className="credit-payment-item">
    <div>Taxes</div>
    <div>{utils.pricefy(data.tax)}</div>
   </div>
   <hr style={{ width: '100%', borderColor: '#00000010' }} />
   <div className="credit-payment-item is-total">
    <div>Total</div>
    <div
     style={{ fontSize: '23px', fontWeight: '600' }}
     className="text-primary"
    >
     {utils.pricefy(data.amount)}{' '}
     <span style={{ fontSize: '13px' }}>{data.currency}</span>
    </div>
   </div>
  </div>
 )
}

export default CreditsPaymentSummary
